const eliminarDuplicadosEnArreglo = (dataArray, keyCode) => {
  const dataArrayMap = dataArray?.map( item => [item[keyCode], item] )  // CREA UN NUEVO ARREGLO DE LLAVE, VALOR
  return [...new Map(dataArrayMap).values()];   // PAR DE CÓDIGO DE CLAVE Y VALOR, ESTO ELIMINA LOS DUPLICADOS Y CONVIERTE A ARRAY DE NUEVO
}

const eliminarDuplicadosEnArreglo2 = (dataArray, keyCode) => [...new Map(dataArray.map( item => [item[keyCode], item] )).values()]

const reiniciarEstadoDelFormulario = (elements) => {
  Object.keys(elements).forEach( item => {
      elements[item].isError = false;
  if(elements[item].elementType === "fecha") elements[item].value = null;
      else if(elements[item].elementType === "radio" || elements[item].elementType === "autoCompletar") elements[item].value = null;
      else if(elements[item].elementType === "archivo") elements[item].value = null;
      else elements[item].value = "";

      // Clear transient file metadata to avoid stale filename previews after reset
      if (Object.prototype.hasOwnProperty.call(elements[item], 'nameOfFile')) {
        elements[item].nameOfFile = "";
      }
  })

  return elements;
}

const descargarBase64EnPDF=function(data,name) {
    const linkSource = `data:application/pdf;base64,${data}`;
    const downloadLink = document.createElement("a");
    const fileName = name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

const ordenarArreglo =function(array,attribute){
    return array?.sort(function(a,b){
        if(a[attribute]< b[attribute]) return -1;
        if(a[attribute] >b[attribute]) return 1;
        return 0;
      });
}

const dividirFecha = function (date) {
    if (date !== undefined) {
      if (date !== null) {
        var arr1 = date.split("-");
        if (arr1.length === 1) return date;
        var arr2 = arr1[2].split("T");
        return arr2[0] + "/" + arr1[1] + "/" + arr1[0];
      }
    }
};

const cambiarFormatoFecha = function (date) {
  if (date) {
    if (typeof date == "string") {
      var dateSplit = date.split("-");
      if (dateSplit.length === 1) return date;
      return dateSplit[0] + "/" + dateSplit[1] + "/" + dateSplit[2];
    }
  }
};

const FormatearFecha = (date, dataToReturn = "") => {
    if (date) {
      if (typeof date == "string") {
        return dividirFecha(date);
      }

      const start = new Date(`${date?.toDateString()}`);
      const options = { year: "numeric", month: "numeric", day: "2-digit" };
      return start.toLocaleDateString("es-ES", options);
    }
    return dataToReturn;
};

const FormatearFechaLarga = (date, fechaObtener = '') => {
    const start = new Date(`${date?.toDateString()}`);
    let options = {}
    if(fechaObtener === 'mes') options = { month:'long', year:'numeric' }
    else options = { weekday:'long', day:'numeric', month:'long', year:'numeric' }
    return start.toLocaleDateString("es-ES", options);
}

const formatearFechaDD_MM_YYYY = (fecha) => {
  if(!fecha) return "";
  const fechaFormateada = new Date(fecha);
  return `${fechaFormateada.getDate()}-${fechaFormateada.getMonth() + 1}-${fechaFormateada.getFullYear()}`
}

const formatearFechaYYYY_MM_DD = (fecha) => {
  if(!fecha) return "";
  const fechaFormateada = new Date(fecha);
  if(fechaFormateada.getDate() === 31) {
    const fechaSplit = fecha.split("+");
    if(fechaSplit.length > 0) return fechaSplit[0];
  }

  return `${fechaFormateada.getFullYear()}/${fechaFormateada.getMonth() + 1}/${ fechaFormateada.getDate() + 1}`
}

const downloadPDFFromStringBase64=function(data,name) {
  const linkSource = `data:application/pdf;base64,${data}`;
  const downloadLink = document.createElement("a");
  const fileName = name;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

const formatearFecha_MM_DD_YYYY = (fecha) => {
  if(!fecha) return "";
  const fechaSplit = fecha.split('/')
  return `"${fechaSplit[1]}-${ fechaSplit[0]}-${fechaSplit[2]}"`

}

const formatearFecha_FINAL_MM_DD_YYYY = (fecha) => {
  if(!fecha) return "";
  const fechaSplit = fecha.split('/')
  const nuevaFecha = new Date(`${fechaSplit[1]}-${ fechaSplit[0] }-${fechaSplit[2]}`.toString())
  return `${nuevaFecha.getMonth() + 1}-${nuevaFecha.getDate() + 1}-${nuevaFecha.getFullYear()}`

}

export const functions={
  eliminarDuplicadosEnArreglo,
  eliminarDuplicadosEnArreglo2,
  reiniciarEstadoDelFormulario,
  descargarBase64EnPDF,
  ordenarArreglo,
  dividirFecha,
  FormatearFecha,
  FormatearFechaLarga,
  formatearFechaDD_MM_YYYY,
  formatearFechaYYYY_MM_DD,
  cambiarFormatoFecha,
  downloadPDFFromStringBase64,
  formatearFecha_MM_DD_YYYY,
  formatearFecha_FINAL_MM_DD_YYYY
};

